import { Container } from "@mui/material";
import * as React from "react";
import { Outlet } from "react-router-dom";

export default function TeamsContainer() {
  return (
    <Container maxWidth="lg">
      <Outlet />
    </Container>
  );
}
